import { render, staticRenderFns } from "./ConnectionsHistoryTableMobile.vue?vue&type=template&id=024522a3&scoped=true"
import script from "./ConnectionsHistoryTableMobile.vue?vue&type=script&lang=js"
export * from "./ConnectionsHistoryTableMobile.vue?vue&type=script&lang=js"
import style0 from "./ConnectionsHistoryTableMobile.vue?vue&type=style&index=0&id=024522a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024522a3",
  null
  
)

export default component.exports